import React from 'react';
import Hero from '../components/Hero';
import OperationalSystems from '../components/OperationalSystems';
import Industries from '../components/Industries';
import AutomationDiagram from '../components/AutomationDiagram';
import Dashboard from '../components/Dashboard';
import ProcessSteps from '../components/ProcessSteps';
import Testimonials from '../components/Testimonials';
import FinalCTA from '../components/FinalCTA';

const Home = () => {
  return (
    <div>
      <Hero />
      <OperationalSystems />
      <Industries />
      <AutomationDiagram />
      <Dashboard />
      <ProcessSteps />
      <Testimonials />
      <FinalCTA />
    </div>
  );
};

export default Home;
